import script from "./resettip.vue?vue&type=script&setup=true&lang=js"
export * from "./resettip.vue?vue&type=script&setup=true&lang=js"

import "./resettip.vue?vue&type=style&index=0&id=30cda132&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30cda132"]])

export default __exports__